import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.sendNotification.loading;
export const selectIsSaved = (state: RootState) => state.sendNotification.saved;
export const selectErrorMessage = (state: RootState) =>
  state.sendNotification.error;
export const sendNotificationDataResponse = (state: RootState) =>
  state.sendNotification.sendNotificationResponse;
